<div class="alert-wrapper">
  <div id="success">
    <ng-container [ngSwitch]="resultstate.alertType">

      <ng-container *ngSwitchCase="'Success'">
        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
          <g id="ic-ok" transform="translate(0 -12)">
            <g id="ok" transform="translate(0 12)">
              <g id="Oval_55" data-name="Oval 55">
                <g id="Oval_55-2" data-name="Oval 55" fill="#00a10b" stroke="#00a10b" stroke-miterlimit="10"
                  stroke-width="2">
                  <circle cx="30" cy="30" r="30" stroke="none" />
                  <circle cx="30" cy="30" r="29" fill="none" />
                </g>
                <circle id="Oval_55-3" data-name="Oval 55" cx="30" cy="30" r="30" fill="none" />
              </g>
              <path id="Path_3" data-name="Path 3" d="M0,10.672l6.621,6.4L24.178,0" transform="translate(18.622 21.889)"
                fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"
                stroke-width="4" />
            </g>
          </g>
        </svg>
      </ng-container>

      <ng-container *ngSwitchCase="'Failed'">
        <i _ngcontent-wsp-c4="" class="icon-spacing failur-icon-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" width="17.657" height="17.657" viewBox="0 0 17.657 17.657">
            <g id="Group_11535" data-name="Group 11535" transform="translate(-5694.015 -487.515)">
              <g id="Group_10713" data-name="Group 10713" transform="translate(24.54 2.54)">
                <line id="Line_325" data-name="Line 325" x2="12" y2="12" transform="translate(5672.304 487.804)"
                  fill="none" stroke="#F40000" stroke-linecap="round" stroke-width="4"></line>
                <line id="Line_326" data-name="Line 326" x1="12" y2="12" transform="translate(5672.304 487.804)"
                  fill="none" stroke="#F40000" stroke-linecap="round" stroke-width="4"></line>
              </g>
            </g>
          </svg>
        </i>
      </ng-container>

      <ng-container *ngSwitchCase="'Warning'">
        <i _ngcontent-wsp-c4="" class="icon-spacing" style="
            width: 60px;
            height: 60px;
            background-color: #ff0000;
            border-radius: 50%;
            line-height: 60px;
          ">
          <svg xmlns="http://www.w3.org/2000/svg" width="17.657" height="17.657" viewBox="0 0 17.657 17.657">
            <g id="Group_11535" data-name="Group 11535" transform="translate(-5694.015 -487.515)">
              <g id="Group_10713" data-name="Group 10713" transform="translate(24.54 2.54)">
                <line id="Line_325" data-name="Line 325" x2="12" y2="12" transform="translate(5672.304 487.804)"
                  fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-width="4"></line>
                <line id="Line_326" data-name="Line 326" x1="12" y2="12" transform="translate(5672.304 487.804)"
                  fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-width="4"></line>
              </g>
            </g>
          </svg>
        </i>
      </ng-container>

    </ng-container>

    <h2 [hidden]="resultstate.successMsgNumber">{{ resultstate.title | titlecase }}</h2>

    <div class="result-message">
      <ng-container *ngIf="resultstate.message">
        <p [ngClass]="{ 'message':resultstate.successMsgNumber }" [innerHTML]="resultstate.message"></p>
      </ng-container>

      <!-- <ng-container *ngIf="resultstate.paymentData">
        <div class="payment-data">
          <div class="payment-data-item">
            <div class="title">
              {{ "RESULTPAGE.referenceNumber" | translate }}
            </div>
            <div class="value">
              {{ resultstate.paymentData.referenceNumber }}
            </div>
          </div>

          <ng-contaner *ngIf="isAdd">
            <div class="payment-data-item">
              <div class="title">
                {{ "RESULTPAGE.paymentAmount" | translate }}
              </div>
              <div class="value">
                {{ resultstate.paymentData.paymentAmount | currencyFormatter }}
                <span class="currency">{{
                  resultstate.paymentData.paymentCurrency
                }}</span>
              </div>
            </div>

            <div class="payment-data-item">
              <div class="title">{{ "RESULTPAGE.from" | translate }}</div>
              <div class="value">
                {{ resultstate.paymentData.fromAccountNumber }}
              </div>
            </div>

            <div class="payment-data-item">
              <ng-container
                *ngIf="resultstate.paymentData.toAccountNumber; else beneId"
              >
                <div class="title">{{ "RESULTPAGE.to" | translate }}</div>
                <div class="value">
                  {{ resultstate.paymentData.toAccountNumber }}
                </div>
              </ng-container>
              <ng-template #beneId>
                <div class="title">{{ "RESULTPAGE.to" | translate }}</div>
                <div class="value">{{ resultstate.paymentData.beneId }}</div>
              </ng-template>
            </div>

            <div class="payment-data-item">
              <div class="title">
                {{ "RESULTPAGE.dateAndTime" | translate }}
              </div>
              <div class="value">{{ resultstate.paymentData.date }}</div>
            </div>
          </ng-contaner>
        </div>
  
        <ng-container *ngIf="resultstate.paymentData.isScheduled != '1'">
          <div class="link-btn-container">
            <span *ngIf="isFavorite">Payment saved as Favourite</span>
            <button
              *ngIf="!isFavorite"
              type="button"
              class="btn-link"
              clickable
              (click)="makeAsFavourite(resultstate)"
            >
              <span>{{ "RESULTPAGE.saveAsFavourite" | translate }}</span>
            </button>
          </div>
        </ng-container>
  
      </ng-container> -->
    </div>
    <ng-container *ngIf="resultstate.additionalFields">
      <div class="payment-data">
        <ng-container *ngFor="let additionalFields of resultstate.additionalFields ">
          <div class="payment-data-item">
            <div class="title">{{ additionalFields.label }}</div>
            <div class="colon">:</div>
            <div class="value"> {{ additionalFields.value }}</div>
          </div>
        </ng-container>  
      </div> 
    </ng-container >
    <ng-container *ngIf="_resultService.hiddenData && _resultService.hiddenData?.enableFav">
    <div class="link-btn-container">
      <span *ngIf="isFavorite">Payment saved as Favourite</span>
      <button
        *ngIf="!isFavorite"
        type="button"
        class="btn-link"
        clickable
        (click)="makeAsFavourite(resultstate)"
      >
        <span>{{ "RESULTPAGEMESSAGE.saveAsFavourite" | translate }}</span>
      </button>
    </div>
    </ng-container>
    <div class="button-grp">
      <ng-container *ngFor="let item of resultstate.navigationDtls">
          <ng-container *ngIf="item.btnType; else defaultButton">
            <button class="btn-{{item.btnType}}" type="button" clickable (click)="resultButtonClickHandler(item)">
              {{ item.btnLabel }}
            </button>
          </ng-container>
          <ng-template #defaultButton>
            <button class="btn-primary" clickable type="button" (click)="resultButtonClickHandler(item)">
              {{ item.btnLabel }}
            </button>
          </ng-template>
      </ng-container>
    </div>

  </div>
</div>